// extracted by mini-css-extract-plugin
export default {"linkWrap":"ResetPassword_linkWrap__zio+G","errorMsg":"ResetPassword_errorMsg__Fz6JG"};